import React, { useState } from 'react';

const Trabalhista = () => {
    const [salario, setSalario] = useState('');
    const [tempoServico, setTempoServico] = useState('');
    const [horasExtras, setHorasExtras] = useState('');
    const [diasFerias, setDiasFerias] = useState('');
    const [resultado, setResultado] = useState(null);

    const calcularTrabalhista = () => {
        if (!salario || !tempoServico || !horasExtras || !diasFerias) {
            alert('Por favor, preencha todos os campos.');
            return;
        }

        const salarioNum = parseFloat(salario);
        const tempoServicoNum = parseInt(tempoServico);
        const horasExtrasNum = parseFloat(horasExtras);
        const diasFeriasNum = parseInt(diasFerias);

        if (isNaN(salarioNum) || isNaN(tempoServicoNum) || isNaN(horasExtrasNum) || isNaN(diasFeriasNum)) {
            alert('Por favor, insira valores válidos.');
            return;
        }

        // Cálculo da rescisão
        const avisoPrevio = salarioNum; // Aviso prévio indenizado
        const saldoSalario = (salarioNum / 30) * (tempoServicoNum % 30); // Saldo de salário pelos dias trabalhados no último mês
        const decimoTerceiroProporcional = (salarioNum / 12) * tempoServicoNum; // 13º salário proporcional
        const feriasProporcionais = ((salarioNum / 12) * tempoServicoNum) + ((salarioNum / 3) * (tempoServicoNum / 12)); // Férias proporcionais com 1/3 adicional

        // Cálculo de horas extras (50% adicional)
        const valorHora = salarioNum / 220; // Considerando jornada de 220 horas/mês
        const valorHorasExtras = horasExtrasNum * valorHora * 1.5; // Adicional de 50%

        // Cálculo das férias vencidas
        const valorFeriasVencidas = (salarioNum / 30) * diasFerias + (salarioNum / 3) * (diasFerias / 30); // Férias com 1/3 adicional

        // Somatório da rescisão
        const totalRescisao = avisoPrevio + saldoSalario + decimoTerceiroProporcional + feriasProporcionais + valorHorasExtras + valorFeriasVencidas;

        // Formatação dos valores
        const formatarValor = (valor) => `R$ ${valor.toFixed(2).replace('.', ',')}`;

        // Atualiza o resultado
        setResultado({
            avisoPrevio: formatarValor(avisoPrevio),
            saldoSalario: formatarValor(saldoSalario),
            decimoTerceiro: formatarValor(decimoTerceiroProporcional),
            feriasProporcionais: formatarValor(feriasProporcionais),
            horasExtras: formatarValor(valorHorasExtras),
            feriasVencidas: formatarValor(valorFeriasVencidas),
            totalRescisao: formatarValor(totalRescisao),
        });
    };

    const limparCampos = () => {
        setSalario('');
        setTempoServico('');
        setHorasExtras('');
        setDiasFerias('');
        setResultado(null);
    };

    return (
        <div className='container-calculo'>
            <div className='label-calculo'>
                <h1 className='titulo-calculo'>Cálculo Trabalhista</h1>
            </div>

            <div className='label-calculo'>
                <h3 className='txt-calculo'>Salário Bruto:</h3>
                <input
                    className='input-calculo'
                    type='number'
                    value={salario}
                    onChange={(e) => setSalario(e.target.value)}
                />
            </div>

            <div className='label-calculo'>
                <h3 className='txt-calculo'>Tempo de Serviço (em meses):</h3>
                <input
                    className='input-calculo'
                    type='number'
                    value={tempoServico}
                    onChange={(e) => setTempoServico(e.target.value)}
                />
            </div>

            <div className='label-calculo'>
                <h3 className='txt-calculo'>Horas Extras (número de horas):</h3>
                <input
                    className='input-calculo'
                    type='number'
                    value={horasExtras}
                    onChange={(e) => setHorasExtras(e.target.value)}
                />
            </div>

            <div className='label-calculo'>
                <h3 className='txt-calculo'>Dias de Férias Vencidas:</h3>
                <input
                    className='input-calculo'
                    type='number'
                    value={diasFerias}
                    onChange={(e) => setDiasFerias(e.target.value)}
                />
            </div>

            <div className="btn-container">
                <button className='btn-calculo-limpar' onClick={limparCampos}>
                    Limpar
                </button>
                <button className='btn-calculo' onClick={calcularTrabalhista}>
                    Calcular
                </button>
            </div>
            {resultado && (<hr className='hr-separador'></hr>)}
            {resultado && (
                <div className='resultado-calculo'>
                    <h3 className='titulo-resultado' >Resultado do Cálculo Trabalhista</h3>
                    <p className='txt-resultado'>Aviso Prévio: {resultado.avisoPrevio}</p>
                    <p className='txt-resultado'>Saldo de Salário: {resultado.saldoSalario}</p>
                    <p className='txt-resultado'>13º Proporcional: {resultado.decimoTerceiro}</p>
                    <p className='txt-resultado'>Férias Proporcionais (com 1/3): {resultado.feriasProporcionais}</p>
                    <p className='txt-resultado'>Valor de Horas Extras: {resultado.horasExtras}</p>
                    <p className='txt-resultado'>Férias Vencidas (com 1/3): {resultado.feriasVencidas}</p>
                    <hr className='hr-resultado'/>
                    <p className='txt-resultado'><strong>Total da Rescisão: {resultado.totalRescisao}</strong></p>
                </div>
            )}
        </div>
    );
};

export default Trabalhista;
